import React from "react"
import { useMediaQuery } from "@cd2/components"
import { breakpoints } from "../constants/breakpoints"

export function useMediaBreakpoints(ref?: React.RefObject<HTMLElement>) {
  const [isMobile, isTablet, isDesktop, isLargeDesktop] = useMediaQuery(
    [
      { maxWidth: breakpoints.phone },
      { minWidth: breakpoints.phone + 1, maxWidth: breakpoints.tablet },
      { minWidth: breakpoints.tablet + 1 },
      { minWidth: breakpoints.desktop + 1 },
    ],
    { ref },
  )

  return { isMobile, isTablet, isDesktop, isLargeDesktop }
}
